import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="export-form"
export default class extends Controller {
  static targets = [ "selectAll", "fieldCheckbox", "reverseSelection" ]

  connect() {
    this.updateSelectAllState()
  }

  // Handle "Select All" checkbox
  toggleAll() {
    const isChecked = this.selectAllTarget.checked
    this.fieldCheckboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
  }

  // Handle individual field checkboxes
  toggleField() {
    this.updateSelectAllState()
  }

  // Update "Select All" checkbox state based on individual checkboxes
  updateSelectAllState() {
    const totalCheckboxes = this.fieldCheckboxTargets.length
    const checkedCheckboxes = this.fieldCheckboxTargets.filter(checkbox => checkbox.checked).length
    
    if (checkedCheckboxes === 0) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    } else if (checkedCheckboxes === totalCheckboxes) {
      this.selectAllTarget.checked = true
      this.selectAllTarget.indeterminate = false
    } else {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = true
    }
  }

  // Handle "Click to reverse selection" functionality
  reverseSelection(event) {
    event.preventDefault()
    
    // Find the specific section that was clicked
    const clickedSection = event.currentTarget.closest('.control-group')
    
    // Find all checkboxes within this specific section
    const sectionCheckboxes = clickedSection.querySelectorAll('input[data-export-form-target="fieldCheckbox"]')
    
    // Toggle only the checkboxes in this section
    sectionCheckboxes.forEach(checkbox => {
      checkbox.checked = !checkbox.checked
    })
    
    this.updateSelectAllState()
  }
} 